/*
 * @Author: Teemo Ding
 * @Date: 2021-09-14 16:42:47
 * @LastEditTime: 2022-06-10 14:27:29
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelDomain/List/Domains/index.tsx
 */
import { Button, Form } from '@/src/components/Antd';
import ModalFooter from '@/src/components/Antd/Modal/ModalFooter';
import Table from '@/src/components/Antd/Table/SizeFittingTable';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import {
  connect_domain,
  delete_domain,
} from '@/src/request/salesChannel/setting/domain';
import { NEW } from '@/src/tools/constant';
import { EnumStatus, RequestType } from '@/src/types/common/domain';
import React, { Fragment } from 'react';
import { useHistory, useParams } from 'react-router';
import ModalHoc from 'src/constrains/ModalHOC';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { ActionType, columns } from '../config';
import css from '../css.module.less';

const { Item } = Form;
interface DomainsTableIProps {
  value?: any;
  onChange?: () => void;
  initPageData?: any;
  modalOp?: any;
  disabled?: boolean;
}
const DomainsTable = ModalHoc((props: DomainsTableIProps) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    value,
    initPageData,
    modalOp: { setShowModal, setModalTitle, setModalContent },
    disabled,
  } = props;
  const history = useHistory();
  const params: any = useParams();
  const { uuid: salesChannelUuid } = params;

  const connectedDomains = (value || []).filter(
    (o) => o.status == EnumStatus.Connected,
  );
  const otherDomains = (value || []).filter(
    (o) => o.status !== EnumStatus.Connected,
  );

  const handleGoToAdd = () => {
    history.push(`/salesChannel/setting/domain/${salesChannelUuid}/${NEW}`);
  };

  const handleGoToEdit = (domainUuid) => {
    history.push(
      `/salesChannel/setting/domain/${salesChannelUuid}/${domainUuid}`,
    );
  };

  const handleConnectDomain = (domainUuid) => {
    connect_domain(domainUuid).then((data) => {
      initPageData(RequestType.Domains);
    });
  };

  const handleConnectConfirm = (domainUuid) => {
    if (connectedDomains.length) {
      setShowModal(true);
      setModalTitle('Connect Domain');
      setModalContent(
        <div>
          <p className={css.connectModal}>
            {getI18n('salesChannelDomainAndStatus.list.domainscontentModal')}
          </p>
          <ModalFooter
            onOk={() => handleConnectDomain(domainUuid)}
            onCancel={() => setShowModal(false)}
            okText={getI18n('salesChannelDomainAndStatus.list.connect')}
          />
        </div>,
      );
    } else {
      handleConnectDomain(domainUuid);
    }
  };

  const handleActionFun = (domainUuid, type: ActionType) => {
    const actionDo = {
      [ActionType.Edit]: handleGoToEdit,
      [ActionType.Connect]: handleConnectConfirm,
      [ActionType.Delete]: delete_domain,
    };
    if (type == ActionType.Delete) {
      actionDo[type](domainUuid).then((data) => {
        initPageData(RequestType.Domains);
      });
    } else {
      actionDo[type](domainUuid);
    }
  };

  return (
    <Fragment>
      <p className={css.domainsLabel}>
        {getI18n('salesChannelDomainAndStatus.list.connectedDomain')}
      </p>
      <Table
        id='domains'
        rowKey='uuid'
        columns={columns(handleActionFun, disabled, { getI18n })}
        dataSource={connectedDomains}
        pagination={false}
      />
      {otherDomains.length ? (
        <div className={css.otherDomains}>
          <p className={css.domainsLabel}>
            {getI18n('salesChannelDomainAndStatus.list.otherDomain')}
          </p>
          <Table
            id='domains'
            rowKey='uuid'
            columns={columns(handleActionFun, disabled, { getI18n })}
            dataSource={otherDomains}
            pagination={false}
          />
        </div>
      ) : null}

      <div className={css.buttonCombin}>
        <Button type='primary' onClick={handleGoToAdd} disabled={disabled}>
          {getI18n('salesChannelDomainAndStatus.list.addDomain')}
        </Button>
      </div>
    </Fragment>
  );
});

const Domains = ({ initPageData, disabled }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      containerClassName={css.containerClassName}
      title={getI18n('salesChannelDomainAndStatus.list.domains')}>
      <Item name='domains'>
        <DomainsTable initPageData={initPageData} disabled={disabled} />
      </Item>
    </SectionWrapper>
  );
};

export default Domains;
